import {
  FETCH_CASE_DETAILS_BY_CASE_ID,
  FETCH_CASE_DETAILS_BY_CASE_ID_FAIL,
  FETCH_CASE_DETAILS_BY_CASE_ID_SUCCESS,
  RELOAD_CASE_DETAILS
} from '../../actions/cm/caseDetails';

export const initialState = {
  isLoading: false,
  hasError: false,
  hasLoaded: false,
  caseDetails: null,
  errorMessage: null
};

export default function (state = initialState, { type, payload }) {
  switch (type) {
    case FETCH_CASE_DETAILS_BY_CASE_ID:
      return {
        ...state,
        isLoading: true,
        hasError: false
      };
    case FETCH_CASE_DETAILS_BY_CASE_ID_SUCCESS:
      return {
        ...state,
        caseDetails: payload,
        isLoading: false,
        hasLoaded: true
      };
    case FETCH_CASE_DETAILS_BY_CASE_ID_FAIL:
      return {
        ...state,
        isLoading: false,
        hasError: true,
        hasLoaded: true,
        caseDetails: null,
        errorMessage: payload.message
      };
    case RELOAD_CASE_DETAILS:
      return {
        ...state,
        hasLoaded: false
      };
    default:
      return state;
  }
}
